import { useState } from "react";
import { Link } from "react-router-dom";
import { ARTICLES, ARTICLE_CATEGORIES } from "@/data/articles";
import { SectionHeader, Reveal } from "@/components/SectionHeader";
import SEO from "@/components/SEO";

export default function LearningCenter() {
  const [cat, setCat] = useState("All");
  const filtered = cat === "All" ? ARTICLES : ARTICLES.filter((a) => a.category === cat);

  return (
    <div data-testid="learning-page">
      <SEO
        title="Learning Center — Texas Environmental Knowledge Library"
        description="Educational articles on mold, indoor air quality, building science, water damage, sampling, laboratory interpretation, remediation protocols, and Texas regulations."
        path="/learning"
      />
      <section className="bg-[#F8FAFC] py-24">
        <div className="container-x">
          <div className="overline mb-5">Learning center</div>
          <h1 className="font-display text-5xl sm:text-6xl font-extrabold tracking-tight text-[#0F172A] leading-[1.05] max-w-4xl">
            Texas's growing environmental knowledge library.
          </h1>
          <p className="mt-8 text-lg text-slate-600 max-w-2xl leading-relaxed">
            Educational, sales-free, and grounded in the standards that govern our work.
          </p>
        </div>
      </section>

      <section className="section-pad bg-white">
        <div className="container-x">
          <div className="flex flex-wrap gap-2 mb-12">
            {["All", ...ARTICLE_CATEGORIES].map((c) => (
              <button
                key={c}
                data-testid={`learning-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setCat(c)}
                className={`text-xs uppercase tracking-wider font-semibold px-4 py-2 rounded-full border transition-colors ${
                  cat === c
                    ? "bg-[#0F172A] text-white border-[#0F172A]"
                    : "bg-white text-slate-600 border-slate-200 hover:border-[#0F172A]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((a, i) => (
              <Reveal key={a.slug} delay={i * 0.04}>
                <Link to={`/learning/${a.slug}`} data-testid={`article-card-${a.slug}`} className="card-soft block p-7 h-full">
                  <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#7C3AED]">{a.category}</div>
                  <h3 className="font-display font-bold text-lg text-[#0F172A] mt-3 leading-snug">{a.title}</h3>
                  <p className="text-sm text-slate-600 mt-3 leading-relaxed">{a.excerpt}</p>
                  <div className="mt-6 text-xs text-slate-500">{a.readMin} min read</div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
